module.exports = __webpack_public_path__ + "static/video_3-13e695585dc10ca70824f91b12c91f9b.webm";